export const authTypes = {
    AUTH_REQUEST: "./auth/AUTH_REQUEST",
    AUTH_SUCCESS: "./auth/AUTH_SUCCESS",
    AUTH_FAILURE: "./auth/AUTH_FAILURE",
    VERIFY_TOKEN_REQUEST: "./auth/VERIFY_TOKEN_REQUEST",
    VERIFY_TOKEN_SUCCESS: "./auth/VERIFY_TOKEN_SUCCESS",
    VERIFY_TOKEN_FAILURE: "./auth/VERIFY_TOKEN_FAILURE",
}